"use client";

import { Toaster } from "@/components/shadcn/ui/sonner";

export const ToasterClient = () => {
  return <Toaster />;
};
